<template>
	<div class="login-page">
		<!-- <video :src="backgroundVideo" autoplay loop muted :poster="backgroundImage">您的浏览器不支持HTML5视频标签。</video> -->
		<img class="bg" src="@/assets/bg.png" alt="" />
		<!-- <router-link tag="div" class="logo" :to="{ name: 'home' }">
			<svg-icon name="logo" />
		</router-link> -->
		<div class="body">
			<div class="body-left">
				<div class="heading-1">中国集装箱行业</div>
				<div class="heading-2">绿色低碳公共服务平台</div>
				<!-- <div class="des">探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设</div> -->
			</div>
			<div class="body-right">
				<!-- 注册 -->
				<el-form :model="registerForm" :rules="registerRule" ref="registerForm" class="card register-card" v-if="true">
					<div class="heading">欢迎注册</div>
					<!-- <svg-icon name="logo2"></svg-icon> -->
					<el-form-item prop="mobile">
						<div class="phone-box">
							<el-input type="number" v-maxlength="11" clearable v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
							<div class="prefix">+86</div>
						</div>
					</el-form-item>
					<el-form-item prop="confirmSuccess">
						<div class="slide" @mousedown.capture="checkCanSliderCode">
							<SliderCode :key="sliderKey" ref="SliderCode" @confirmSuccessBool="confirmSuccessFn"></SliderCode>
						</div>
					</el-form-item>
					<el-form-item prop="verificationCode">
						<div class="code-box">
							<el-input type="number" v-maxlength="6" clearable v-model="registerForm.verificationCode" placeholder="请输入验证码"></el-input>
							<div class="suffix" @click="sendCode">
								<CountDown ref="CountDown" :seconds="60" class="yanzhengma-btn"></CountDown>
							</div>
						</div>
					</el-form-item>
					<el-button class="login-btn" type="primary" @click="toApply">下一步</el-button>
					<div class="card-footer">
						<div class="register">
							已有账户!
							<router-link tag="div" class="tologin" :to="{ name: 'login' }">
								<span class="c-primary c-pointer">去登录</span>
								<img src="@/assets/img/002.png" alt="" />
							</router-link>
						</div>
					</div>
				</el-form>
			</div>
		</div>
		<div class="footer">
			<div class="field">版权所有 {{ webInfo.copyright }}</div>
			<div class="field">联系方式：{{ webInfo.email }}</div>
		</div>

		<!-- 拼图验证 -->
		<Vcode :show="isShow" @success="onSuccess" @close="onClose" />
	</div>
</template>

<script>
import { NSlider, SmsSend, ConfigValue, ValidatePerson } from '@/common/api.js';
import SliderCode from '@/components/SliderCode/SliderCode.vue';
import CountDown from '@/components/CountDown/CountDown.vue';
import useJsencrypt from '@/common/useJsencrypt.js';
import { webInfo } from '@/common/data.js';
// 拼图验证
import Vcode from 'vue-puzzle-vcode';
export default {
	components: { SliderCode, CountDown, Vcode },
	data() {
		// 手机号验证
		var validatePhone = (rule, value, callback) => {
			let result = this.verifyVal({ val: value, rules: ['phone'] });
			if (result.valid) {
				callback();
			} else {
				callback(new Error('手机号格式不正确'));
			}
		};
		// 滑块验证
		var validateSlider = (rule, value, callback) => {
			if (value === false) {
				callback(new Error('请将滑块拖动至最右'));
			} else {
				callback();
			}
		};
		return {
			webInfo: webInfo,
			// 背景视频
			backgroundVideo: '',
			// 背景图片
			backgroundImage: '',
			isAgree: false,
			// 注册表单
			registerForm: {
				// 手机号
				mobile: '',
				// 验证码
				verificationCode: '',
				// 滑块验证
				confirmSuccess: false,
				// 滑块验证hash
				code: ''
			},
			registerRule: {
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ validator: validatePhone },
				],
				verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				confirmSuccess: [{ validator: validateSlider }]
			},
			// 是否显示拼图验证
			isShow: false,
			smsSending: false,
			sliderKey: 0
		};
	},
	created() {
		this.getConfigValue();
	},
	methods: {
		// 检查是否可以拖动滑块
		checkCanSliderCode() {
			this.$refs.registerForm.validateField('mobile', (errorMessage) => {
				if (errorMessage) {
					this.$refs.SliderCode.sliderCodeable = false
				} else {
					this.$refs.SliderCode.sliderCodeable = true
				}
			});
		},
		// 获取背景视频、图片
		getConfigValue() {
			ConfigValue({
				configKey: 'login.background.video'
			}).then((res) => {
				this.backgroundVideo = res.data;
			});
			ConfigValue({
				configKey: 'login.background.image'
			}).then((res) => {
				this.backgroundImage = res.data;
			});
		},
		resetSlider() {
			this.registerForm.confirmSuccess = false;
			this.registerForm.code = '';
			this.sliderKey += 1;
		},
		// 发送验证码（滑块票据后端仅 60s，拖完后应尽快发送）
		sendCode() {
			if (this.smsSending) {
				return;
			}
			this.$refs.registerForm.validateField('mobile', (errorMessage) => {
				if (!errorMessage) {
					this.$refs.registerForm.validateField('confirmSuccess', (confirmSuccess_errorMessage) => {
						if (!confirmSuccess_errorMessage) {
							if (this.$refs.CountDown.canGetCode) {
								if (!this.registerForm.code) {
									this.$message.warning('请先完成滑块验证');
									this.resetSlider();
									return;
								}
								let data = {
									smsType: 'register',
									code: useJsencrypt(this.registerForm.code)
								};
								this.smsSending = true;
								SmsSend(data)
									.then((res) => {
										if (res.success) {
											if (res.code === '163') {
												this.onShow();
											} else {
												this.$message.success('发送成功');
												this.$refs.CountDown.start();
												this.resetSlider();
											}
										} else {
											this.$message.error(res.message || '发送失败');
											if ((res.message || '').indexOf('已失效') !== -1) {
												this.$message.warning('滑块已过期，请重新拖动后再获取验证码');
											}
											this.resetSlider();
										}
									})
									.finally(() => {
										this.smsSending = false;
									});
							}
						}
					});
				}
			});
		},
		// 打开拼图验证
		onShow() {
			this.isShow = true;
		},
		// 关闭拼图验证
		onClose() {
			this.isShow = false;
		},
		// 拼图验证成功
		onSuccess() {
			let data = {
				mobile: this.registerForm.mobile
			};
			ValidatePerson(data).then((res) => {
				if (res.success) {
					this.onClose();
					this.sendCode();
				}
			});
		},
		// 去注册申请
		toApply() {
			this.$refs.registerForm.validate((valid) => {
				if (valid) {
					let obj = {
						mobile: this.registerForm.mobile,
						verificationCode: this.registerForm.verificationCode
					};
					this.$store.commit('changeRegInfo', obj);
					this.$router.push({ name: 'registerApply' });
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 滑块操作成功：拿到票据后立即发短信，避免超过后端 60s 有效期
		confirmSuccessFn(val) {
			this.registerForm.confirmSuccess = val;
			if (!val) {
				return;
			}
			let data = {
				mobile: this.registerForm.mobile
			};
			NSlider(data).then((res) => {
				if (res.success || res.code === '200') {
					this.registerForm.code = res.data;
					this.sendCode();
				} else {
					this.$message.error(res.message || '滑块验证失败');
					this.resetSlider();
				}
			}).catch(() => {
				this.resetSlider();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@function vw($px) {
	@return $px / 1440 * 100vw;
}

@function vh($px) {
	@return $px / 735 * 100vh;
}
.login-page {
	// flex: 1;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	// background-image: url('~@/assets/tmp/017.png');
	background-size: cover;
	position: relative;
	video {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}
	.bg {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}
	.svg-logo {
		position: absolute;
		top: 0;
		left: 0;
		margin-top: vh(10);
		margin-left: vw(40);
		width: 328px;
		height: 41px;
	}
	.body {
		flex: 1;
		display: flex;
		justify-content: space-between;
		.body-left {
			margin-left: vw(94);
			flex: 1;
			padding-right: vw(20);
			align-self: center;
			transform: translateY(-160px);
		
			.heading-1 {
				// margin-top: vh(216);
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}
		
			.heading-2 {
				margin-top: 10px;
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}
		
			.des {
				width: 465px;
				margin-top: 73px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 21px;
			}
		}
		.body-right {
			margin-right: vw(90);
			align-self: center;

			// 注册
			.register-card {
				width: 390px;
				height: 460px;
				background: #ffffff;
				box-sizing: border-box;
				padding: 0 28px;
				display: flex;
				flex-direction: column;
				position: relative;
				.heading {
					margin-top: 25px;
					font-weight: bold;
					font-size: 16px;
					color: #000000;
					line-height: 22px;
					text-align: center;
				}
				.svg-logo2 {
					margin-top: 20px;
					width: 307px;
					height: 39px;
					align-self: center;
				}
				.phone-box {
					margin-top: 20px;
					position: relative;
					display: flex;
					align-items: center;
					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 73px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;
								&::placeholder {
									color: #9e9e9e;
								}
							}
							.el-input__icon {
								line-height: 46px;
							}
						}
					}
					.prefix {
						left: 15px;
						position: absolute;
						font-size: 14px;
						color: #000000;
						line-height: 20px;
					}
				}
				.slide {
					margin-top: 20px;
					height: 34px;
					background: #ffffff;
					border: 1px solid #e9e9e9;
				}
				.code-box {
					margin-top: 20px;
					position: relative;
					display: flex;
					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 13px;
								padding-right: 113px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;
								&::placeholder {
									color: #9e9e9e;
								}
							}
							.el-input__suffix {
								right: 113px;
							}
							.el-input__icon {
								line-height: 46px;
							}
						}
					}
					.suffix {
						position: absolute;
						right: 0;
						width: 100px;
						font-size: 14px;
						color: $primary;
						text-align: right;
						box-sizing: border-box;
						padding-right: 13px;
						line-height: 46px;
					}
				}
				.login-btn {
					margin-top: 38px;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					border-radius: 0;
					height: 46px;
					line-height: 46px;
					font-weight: bold;
					font-size: 16px;
				}
				.card-footer {
					height: 56px;
					background: #f8f9fc;
					display: flex;
					position: absolute;
					bottom: 0;
					align-items: center;
					padding: 0 28px;
					justify-content: center;
					width: 100%;
					left: 0;
					box-sizing: border-box;
					.register {
						font-size: 12px;
						color: #9e9e9e;
						display: flex;
						align-items: center;
						.tologin {
							display: flex;
							align-items: center;
						}
						img {
							width: 6px;
							height: 8px;
							margin-left: 5px;
						}
					}
				}
			}
		}
	}
	.footer {
		display: flex;
		justify-content: center;
		position: absolute;
		left: 0;
		right: 0;
		bottom: vh(27);
		.field {
			font-size: 12px;
			color: #ffffff;
			line-height: 27px;
			text-align: center;
			margin: 0 5px;
		}
	}
}
</style>
